import { NavLink } from "react-router-dom";
import { Home, LineChart, Building2, UserRound, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function MobileTabBar() {
  const { user } = useAuth();
  const account = user?.role === "admin" ? { to: "/admin", label: "Admin", icon: ShieldCheck }
    : user?.role === "client" ? { to: "/dashboard", label: "Portfolio", icon: UserRound }
    : { to: "/login", label: "Log in", icon: UserRound };
  const tabs = [
    { to: "/", label: "Home", icon: Home, end: true },
    { to: "/markets", label: "Stocks", icon: LineChart },
    { to: "/properties", label: "Real Estate", icon: Building2 },
    account,
  ];
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-obsidian/90 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden" data-testid="mobile-tab-bar">
      <div className="grid grid-cols-4">
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} data-testid={`mobile-tab-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) => `flex h-16 flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors duration-200 ${isActive ? "text-emerald-400" : "text-slate-400"}`}>
            <Icon className="h-5 w-5" />{label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
